import Editor from './editor';
import { frontendURI } from './list/uri';
import withRouterEditor from '../withRouter';

export default withRouterEditor(frontendURI)(Editor);
